import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const ordersPanelApis = createApi({
  reducerPath: 'ordersPanelApis',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
    prepareHeaders: (headers, { getState }) => {
      // Extract token from state
      const token = getState()?.posData?.token;
      if (token) {
        headers.set('Authorization', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getOrdersPanel: builder.query({
      query: ({chef_id, type}) => ({
        url: `/order/order-panel/${chef_id}?type=${"pos"}`,
        method: 'GET',
      }),
      providesTags: ['ordersPanel'],
    //   transformResponse: (resp) => transformResponseHandler(resp),
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    changeOrderItemStatus: builder.mutation({
        query:({id, body}) => ({
            url: `/order/order-items-status/${id}`,
            method: 'PUT',
            body: body
        }),
        invalidatesTags: ['ordersPanel'],
        transformErrorResponse: (error) => transformResponseHandler(error),
    })
  }),
});

export const { useGetOrdersPanelQuery, useChangeOrderItemStatusMutation } = ordersPanelApis;
